<template>
  <div class="cl-container">
    <div class="cl-title">类别</div>
    <div class="cl-classes">
      <div 
        class="cl-class" 
        v-for="item in classes" 
        :key="item.id" 
        @click="clickClass(item.id)"
      >
        <span>#  </span>
        {{ item.labelName }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    classes: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  methods: {
    clickClass (id) {
      this.$emit('clickClass', id)
    }
  }
}
</script>

<style lang="less" scoped>
.cl-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  .cl-title {
    margin: 0 10px 5px 10px;
    font-size: 10px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #333333;
    line-height: 28px;
    text-align: left;
    border-width: 0 0 0.5px 0;
    border-style: solid;
    border-color: #F2F2F2;
  }
  .cl-classes {
    margin: 12px 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    font-size: 8px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    color: #333333;
    line-height: 12px;
    .cl-class {
      width: 100%;
      background: #FAFAFA;
      border-radius: 2px;
      text-align: left;
      padding: 6px 0;
      margin: 4px 0;
      text-indent: 30px;
      span {
        font-weight: 500;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        color: #FF7486;
      }
    }
  }
}
</style>